import { useQuery } from "@tanstack/react-query";

import { getCommissionDefaults } from "services/commissionDefaults";

/** Keyed per city, because a city may set its own defaults. */
export const commissionDefaultsKeys = {
    all: ["commission-defaults"],
    city: (cityId) => ["commission-defaults", String(cityId || "none")],
};

/**
 * The fallback commission rates, for the settlement cards.
 *
 * It never returns undefined for long: the endpoint fails soft and the cards
 * only draw a number when one arrives.
 *
 * @param {number|string|undefined} cityId
 */
const useCommissionDefaults = (cityId) =>
    useQuery({
        queryKey: commissionDefaultsKeys.city(cityId),
        queryFn: () => getCommissionDefaults(cityId),
        // The rates change when somebody edits a city, which is rare.
        staleTime: 5 * 60_000,
    });

export default useCommissionDefaults;
